import React from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { DeskPanel, DeskPill, DeskEmpty } from "../desktop/DeskTable";
import "../desktop/deskKit.css";
import "./opsDesktop.css";

/** Desktop Open Session: session details beside the Stop / Cancel actions. Same data and handlers as the phone screen. */
export function OpenSessionDesktop({ sessionData, duration, busy, onBack, onStopSession, onCancelSession }) {
  return (
    <CrewPilotModuleShell
      title="Open Session"
      subtitle={sessionData ? "Review or cancel the active workforce session." : "No active session found."}
      layout={PAGE_LAYOUT.COMMAND}
      onBack={onBack}
      backLabel="Dashboard"
      compact
    >
      {!sessionData ? (
        <DeskEmpty title="No active session found.">Start a session from Time Tracking.</DeskEmpty>
      ) : (
        <div className="dp-grid dp-grid--main-side">
          <DeskPanel
            title={sessionData.job_number || "Active Session"}
            actions={<DeskPill tone={sessionData.break_active ? "gold" : "green"}>{sessionData.break_active ? "On Break" : "Active"}</DeskPill>}
          >
            <dl className="dp-kv">
              <dt>Employee</dt>
              <dd>{sessionData.employee_name || "Unknown"}</dd>
              <dt>Status</dt>
              <dd>{sessionData.status || "active"}</dd>
              <dt>Started</dt>
              <dd>
                {new Date(sessionData.session_start).toLocaleString([], {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </dd>
              <dt>Running Time</dt>
              <dd className="dt-num">{duration}</dd>
              <dt>Break Active</dt>
              <dd>{sessionData.break_active ? "Yes" : "No"}</dd>
            </dl>
          </DeskPanel>
          <DeskPanel title="Actions">
            <p className="dp-hint">Stop Time opens Time & Session to finish the session. Cancel discards it without creating a time log.</p>
            <div className="ops-side-actions">
              <button type="button" className="dt-btn dt-btn--primary" onClick={onStopSession} disabled={busy}>
                Stop Time
              </button>
              <button type="button" className="dt-btn dt-btn--danger" onClick={onCancelSession} disabled={busy}>
                {busy ? "Cancelling..." : "Cancel Session"}
              </button>
            </div>
          </DeskPanel>
        </div>
      )}
    </CrewPilotModuleShell>
  );
}
